<app-breadcrumb [breadcrumb]="'ecomproduct'"></app-breadcrumb>


<section class="section-b-space" style="position: static;">
    <div class="container">
        <div class="checkout-page">
            <div class="checkout-form">
                <div class="row">
                    <div class="col-lg-4 col-sm-12 col-xs-12 hidevalue">

                        <div class="checkout-details" style="margin-bottom: 20px;">

                            <div class="order-box">
                                <div class="col-md-12 row">
                                    <div class="col-md-6">
                                        <div class="checkout-title">
                                            <h3>Details</h3>
                                        </div>
                                    </div>

                                </div>
                                <div class="row check-out">






                                </div>
                            </div>
                        </div>
                    </div>


                  

                    <div class="col-lg-8 col-sm-12 col-xs-12 hidevalue">
                        <div class="order-box">
                            <div class="container">
                                <div *ngIf="hide == false">


                                    <tbody>
                                        <tr>
                                            <td>
                                                <table cellpadding="0" cellspacing="0" style="text-align: left;"
                                                    width="100%">
                                                    <tbody>
                                                        <tr>
                                                            <td style="text-align: center;">
                                                                <img src="../assets/images/Delivery-det/delivery-2.png"
                                                                    alt="" style="margin-bottom: 30px;">
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <p style="font-size: 14px;color: black;">
                                                                    <strong style="font-size: 14px;">Hi
                                                                        XXXXXXX,</strong>
                                                                </p>
                                                                <p style="font-size: 14px;">Order Is Successfully
                                                                    Processsed And Your Order Is On The
                                                                    Way,</p>
                                                                <p style="font-size: 14px;">Transaction ID :
                                                                    12345QWERTY,</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table cellpadding="0" cellspacing="0" border="0" align="left"
                                                    style="width: 100%;margin-top: 10px;    margin-bottom: 10px;">
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style="background-color: #fafafa;border: 1px solid #ddd;padding: 15px;letter-spacing: 0.3px;width: 50%;">
                                                                <h5 class="h5text">
                                                                    Shipping Address</h5>
                                                                <p
                                                                    style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                    No:60,RGM Complex,<br> Rajiv Gandhi Salai,
                                                                    Karapakkam<br>Chennai, Tamil Nadu 600097
                                                                </p>
                                                            </td>
                                                            <td><img src="../assets/images/Delivery-det/space.jpg"
                                                                    alt=" " height="25" width="30">
                                                            </td>
                                                            <td
                                                                style="background-color: #fafafa;border: 1px solid #ddd;padding: 15px;letter-spacing: 0.3px;width: 50%;">
                                                                <h5
                                                                    style="font-size: 16px;font-weight: 600;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                                    Billing Address:</h5>
                                                                <p
                                                                    style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                    No:60,RGM Complex,<br> Rajiv Gandhi Salai,
                                                                    Karapakkam<br>Chennai, Tamil Nadu 600097</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table class="order-detail" border="0" cellpadding="0" cellspacing="0"
                                                    align="left" style="width: 100%;    margin-bottom: 50px;">
                                                    <tbody>
                                                        <tr align="left">
                                                            <th>PRODUCT</th>
                                                            <th style="padding-left: 15px;">DESCRIPTION</th>
                                                            <th>QUANTITY</th>
                                                            <th>PRICE </th>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <img src="https://biz1ps.azurewebsites.net/temp/audio/Blackforest-cake-Ecom_new.jpg"
                                                                    alt="" width="80">
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="margin-top: 15px;">BLACK FOREST CAKE </h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top:15px;    margin-bottom: 0px;">
                                                                    Kg :
                                                                    <span> 1.5</span>
                                                                </h5>
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top: 10px;">
                                                                    QTY : <span>2</span></h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="font-size: 14px; color:#444;margin-top:15px">
                                                                    <b>₹1850</b>
                                                                </h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <img src="https://biz1ps.azurewebsites.net/temp/audio/whiteforest-cake-Ecom_new.jpg"
                                                                    alt="" width="80">
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="margin-top: 15px;">WHITE FOREST CAKE </h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top:15px;    margin-bottom: 0px;">
                                                                    Kg :
                                                                    <span> 1.5</span>
                                                                </h5>
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top: 10px;">
                                                                    QTY : <span>1</span></h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="font-size: 14px; color:#444;margin-top:15px">
                                                                    <b>₹1060</b>
                                                                </h5>
                                                            </td>
                                                        </tr>


                                                        <tr class="pad-left-right-space ">
                                                            <td class="m-t-5" colspan="2" align="left">
                                                                <p style="font-size: 14px;">Subtotal : </p>
                                                            </td>
                                                            <td class="m-t-5" colspan="2" align="right">
                                                                <b style="">₹2000</b>
                                                            </td>
                                                        </tr>
                                                        <tr class="pad-left-right-space">
                                                            <td colspan="2" align="left">
                                                                <p style="font-size: 14px;">TAX :</p>
                                                            </td>
                                                            <td colspan="2" align="right">
                                                                <b>₹5</b>
                                                            </td>
                                                        </tr>
                                                 
                                                        <tr class="pad-left-right-space ">
                                                            <td class="m-b-5" colspan="2" align="left">
                                                                <p style="font-size: 14px;">Total :</p>
                                                            </td>
                                                            <td class="m-b-5" colspan="2" align="right">
                                                                <b>₹2600</b>
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                            </td>
                                        </tr>
                                    </tbody>
                                </div>
                                <div *ngIf="hide == true">

                                    <tbody>
                                        <tr>
                                            <td>
                                                <table align="center" border="0" cellpadding="0" cellspacing="0">
                                                    <tbody>
                                                        <tr>
                                                            <td style="text-align: center;border-bottom-style: hidden;"
                                                                class="p-0">
                                                                <img src="../assets/images/Delivery-det/delivery-Sus.png"
                                                                    alt="" style="margin-bottom: 5px;">
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="text-align: center;border-bottom-style: hidden;"
                                                                class="p-0">
                                                                <img src="../assets/images/Delivery-det/success.png"
                                                                    alt="">
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="text-align: center;border-bottom-style: hidden;"
                                                                class="p-0">
                                                                <h2 class="title">thank you</h2>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="    text-align: -webkit-center;border-bottom-style: hidden;"
                                                                class="p-0">
                                                                <p>Payment Is Successfully Processsed And Your Order Is
                                                                    On The
                                                                    Way</p>
                                                                <p>Transaction ID:123</p>
                                                            </td>
                                                        </tr>
                                                        <tr>

                                                            <td>
                                                                <div
                                                                    style="border-top:1px solid #777;height:1px;margin-top: 30px;">
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td style="    border-top-style: hidden;text-align: -webkit-center;">
                                                                <img src="../assets/images/Delivery-det/order-success.png"
                                                                    alt="" style="margin-top: 30px;">
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                          
                                                <table class="order-detail" border="0" cellpadding="0" cellspacing="0"
                                                    align="left">
                                                    <tbody>
                                                        <tr align="left">
                                                            <th>PRODUCT</th>
                                                            <th style="padding-left: 15px;">DESCRIPTION</th>
                                                            <th>QUANTITY</th>
                                                            <th>PRICE </th>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <img src="../assets/images/email-temp/13.jpg" alt=""
                                                                    width="70">
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="margin-top: 15px;">Three seater Wood Style
                                                                    sofa for
                                                                    Leavingroom </h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top:15px;    margin-bottom: 0px;">
                                                                    Size :
                                                                    <span> L</span>
                                                                </h5>
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top: 10px;">
                                                                    QTY :
                                                                    <span>1</span>
                                                                </h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="font-size: 14px; color:#444;margin-top:15px">
                                                                    <b>$500</b>
                                                                </h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>
                                                                <img src="../assets/images/email-temp/14.jpg" alt=""
                                                                    width="70">
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="margin-top: 15px;">Three seater Wood Style
                                                                    sofa for
                                                                    Leavingroom </h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top:15px;    margin-bottom: 0px;">
                                                                    Size :
                                                                    <span> L</span>
                                                                </h5>
                                                                <h5
                                                                    style="font-size: 14px; color:#444;margin-top: 10px;">
                                                                    QTY :
                                                                    <span>1</span>
                                                                </h5>
                                                            </td>
                                                            <td valign="top" style="padding-left: 15px;">
                                                                <h5 style="font-size: 14px; color:#444;margin-top:15px">
                                                                    <b>$500</b>
                                                                </h5>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2"
                                                                style="line-height: 49px;font-size: 13px;color: #000000;padding-left: 20px;text-align:left;border-right: unset;">
                                                                Products:</td>
                                                            <td colspan="3" class="price"
                                                                style="line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                                <b>$2600.00</b>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2"
                                                                style="line-height: 49px;font-size: 13px;color: #000000;padding-left: 20px;text-align:left;border-right: unset;">
                                                                Discount :</td>
                                                            <td colspan="3" class="price"
                                                                style="line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                                <b>$10</b>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2"
                                                                style="line-height: 49px;font-family: Arial;font-size: 13px;color: #000000;padding-left: 20px;text-align:left;border-right: unset;">
                                                                Gift Wripping: </td>
                                                            <td colspan="3" class="price"
                                                                style="line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                                <b>$2600</b>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2"
                                                                style="line-height: 49px;font-size: 13px;color: #000000;
                                                                    padding-left: 20px;text-align:left;border-right: unset;">
                                                                Shipping :</td>
                                                            <td colspan="3" class="price"
                                                                style="
                                                                        line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                                <b>$30</b>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="2"
                                                                style="line-height: 49px;font-size: 13px;color: #000000;
                                                                    padding-left: 20px;text-align:left;border-right: unset;">TOTAL
                                                                PAID :</td>
                                                            <td colspan="3" class="price"
                                                                style="line-height: 49px;text-align: right;padding-right: 28px;font-size: 13px;color: #000000;text-align:right;border-left: unset;">
                                                                <b>$2600</b>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <table cellpadding="0" cellspacing="0" border="0" align="left"
                                                    style="width: 100%;margin-top: 30px;    margin-bottom: 30px;">
                                                    <tbody>
                                                        <tr>
                                                            <td
                                                                style="font-size: 13px; font-weight: 400; color: #444444; letter-spacing: 0.2px;width: 50%;">
                                                                <h5
                                                                    style="font-size: 16px; font-weight: 500;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                                    DILIVERY ADDRESS</h5>
                                                                <p
                                                                    style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                    268 Cambridge Lane New Albany,<br> IN 47150268
                                                                    Cambridge
                                                                    Lane <br>New Albany, IN
                                                                    47150</p>
                                                            </td>
                                                            <td width="57" height="25" class="user-info"><img
                                                                    src="../assets/images/email-temp/space.jpg" alt=" "
                                                                    height="25" width="57"></td>
                                                            <td class="user-info"
                                                                style="font-size: 13px; font-weight: 400; color: #444444; letter-spacing: 0.2px;width: 50%;">
                                                                <h5
                                                                    style="font-size: 16px;font-weight: 500;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                                    SHIPPING ADDRESS</h5>
                                                                <p
                                                                    style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                                    268 Cambridge Lane New Albany,<br> IN 47150268
                                                                    Cambridge
                                                                    Lane <br>New Albany, IN
                                                                    47150</p>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>


                                            </td>
                                        </tr>
                                    </tbody>


                                </div>
                            </div>
                        </div>

                    </div>






                    <div class="col-lg-8 col-sm-12 col-xs-12 mobile-cart-content">
                        <div class="order-box">

                            <tbody>
                                <tr>
                                    <td>
                                        <table cellpadding="0" cellspacing="0" style="text-align: left;" width="100%">
                                            <tbody>
                                                <tr>
                                                    <td style="text-align: center;">
                                                        <img src="../assets/images/Delivery-det/delivery-2.png" alt=""
                                                            style="margin-bottom: 30px;">
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="p-2">
                                                        <p style="font-size: 14px;color: black;">
                                                            <strong style="font-size: 14px;">Hi XXXXXXX111,</strong>
                                                        </p>
                                                        <p style="font-size: 14px;">Order Is Successfully
                                                            Processsed And Your Order Is On The
                                                            Way,</p>
                                                        <p style="font-size: 14px;">Transaction ID :
                                                            12345QWERTY,</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <table cellpadding="0" cellspacing="0" border="0" align="left"
                                            style="width: 100%;margin-top: 10px;    margin-bottom: 10px;">
                                            <tbody>
                                                <tr>
                                                    <td
                                                        style="background-color: #fafafa;border: 1px solid #ddd;padding: 15px;letter-spacing: 0.3px;width: 50%;">
                                                        <h5 class="h5text">
                                                            Shipping Address</h5>
                                                        <p
                                                            style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                            No:60,RGM Complex,<br> Rajiv Gandhi Salai,
                                                            Karapakkam<br>Chennai, Tamil Nadu 600097
                                                        </p>
                                                    </td>
                                                    <td><img src="../assets/images/Delivery-det/space.jpg" alt=" "
                                                            height="25" width="30">
                                                    </td>
                                                    <td
                                                        style="background-color: #fafafa;border: 1px solid #ddd;padding: 15px;letter-spacing: 0.3px;width: 50%;">
                                                        <h5
                                                            style="font-size: 16px;font-weight: 600;color: #000; line-height: 16px; padding-bottom: 13px; border-bottom: 1px solid #e6e8eb; letter-spacing: -0.65px; margin-top:0; margin-bottom: 13px;">
                                                            Billing Address:</h5>
                                                        <p
                                                            style="text-align: left;font-weight: normal; font-size: 14px; color: #000000;line-height: 21px;    margin-top: 0;">
                                                            No:60,RGM Complex,<br> Rajiv Gandhi Salai,
                                                            Karapakkam<br>Chennai, Tamil Nadu 600097</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table class="order-detail" border="0" cellpadding="0" cellspacing="0"
                                            align="left" style="width: 100%;    margin-bottom: 50px;">
                                            <tbody>
                                                <tr align="left">
                                                    <th>PRODUCT</th>
                                                    <th style="padding-left: 15px;">Name</th>
                                                    <th>QTY</th>
                                                    <th>PRICE </th>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img src="https://biz1ps.azurewebsites.net/temp/audio/Blackforest-cake-Ecom_new.jpg"
                                                            alt="" width="80">
                                                    </td>
                                                    <td valign="top" style="padding-left: 15px;">
                                                        <h5 style="margin-top: 15px;">BLACK FOREST CAKE </h5>
                                                    </td>
                                                    <td valign="top" style="padding-left: 15px;">
                                                        <h5
                                                            style="font-size: 14px; color:#444;margin-top:15px;    margin-bottom: 0px;">
                                                            Kg :
                                                            <span> 1.5</span>
                                                        </h5>
                                                        <h5 style="font-size: 14px; color:#444;margin-top: 10px;">
                                                            QTY : <span>2</span></h5>
                                                    </td>
                                                    <td valign="top" style="padding-left: 5px;">
                                                        <h5 style="font-size: 14px; color:#444;margin-top:15px">
                                                            <b>₹1850</b>
                                                        </h5>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <img src="https://biz1ps.azurewebsites.net/temp/audio/whiteforest-cake-Ecom_new.jpg"
                                                            alt="" width="80">
                                                    </td>
                                                    <td valign="top" style="padding-left: 15px;">
                                                        <h5 style="margin-top: 15px;">WHITE FOREST CAKE </h5>
                                                    </td>
                                                    <td valign="top" style="padding-left: 15px;">
                                                        <h5
                                                            style="font-size: 14px; color:#444;margin-top:15px;    margin-bottom: 0px;">
                                                            Kg :
                                                            <span> 1.5</span>
                                                        </h5>
                                                        <h5 style="font-size: 14px; color:#444;margin-top: 10px;">
                                                            QTY : <span>1</span></h5>
                                                    </td>
                                                    <td valign="top" style="padding-left: 5px;">
                                                        <h5 style="font-size: 14px; color:#444;margin-top:15px">
                                                            <b>₹1060</b>
                                                        </h5>
                                                    </td>
                                                </tr>


                                                <tr class="pad-left-right-space ">
                                                    <td class="m-t-5" colspan="2" align="left"
                                                        style="padding-left: 15px;">
                                                        <p style="font-size: 14px;">Subtotal : </p>
                                                    </td>
                                                    <td class="m-t-5" colspan="2" align="right"
                                                        style="padding-left: 15px;">
                                                        <b style="">₹2000</b>
                                                    </td>
                                                </tr>
                                                <tr class="pad-left-right-space">
                                                    <td colspan="2" align="left" style="padding-left: 15px;">
                                                        <p style="font-size: 14px;">TAX :</p>
                                                    </td>
                                                    <td colspan="2" align="right" style="padding-left: 15px;">
                                                        <b>₹5</b>
                                                    </td>
                                                </tr>
                                 
                                                <tr class="pad-left-right-space ">
                                                    <td class="m-b-5" colspan="2" align="left"
                                                        style="padding-left: 15px;">
                                                        <p style="font-size: 14px;">Total :</p>
                                                    </td>
                                                    <td class="m-b-5" colspan="2" align="right"
                                                        style="padding-left: 15px;">
                                                        <b>₹2600</b>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>

                                    </td>
                                </tr>
                            </tbody>
                        </div>



                    </div>
                </div>
            </div>
        </div>
    </div>
</section>